export default "__VITE_ASSET__BIWBdU9M__"